import { useQuery } from '@tanstack/react-query'
import { Loader2 } from 'lucide-react'
import { apiService } from '@/services/api'
import USMap from '@/components/USMap'

export default function Home() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['reserves'],
    queryFn: () => apiService.getReserves(),
  })

  return (
    <div>
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
        <div className="container mx-auto px-4 py-24 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            The Community{' '}
            <span className="text-bitcoin">Bitcoin</span>{' '}
            Reserve
          </h1>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            Empowering neighborhoods to collectively save in Bitcoin through transparent,
            multi-signature custody
          </p>
        </div>
      </section>

      {/* Map Section */}
      <section className="bg-gray-950 py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-white mb-8">
            Reserve Locations
          </h2>

          {isLoading && (
            <div className="flex items-center justify-center py-16">
              <Loader2 className="animate-spin text-bitcoin" size={40} />
              <span className="ml-3 text-gray-300 text-lg">Loading reserves...</span>
            </div>
          )}

          {error && (
            <div className="text-center py-16">
              <p className="text-red-400 text-lg">Failed to load reserves</p>
            </div>
          )}

          {data && <USMap reserves={data.data} />}

          {data && data.data.length === 0 && (
            <p className="text-center text-gray-500 mt-4">
              No reserves have been established yet.
            </p>
          )}
        </div>
      </section>

      {/* History / About Section */}
      <section id="history" className="bg-gray-900 py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-8 text-center">
              About the Movement
            </h2>

            <div className="space-y-6 text-gray-300 text-lg leading-relaxed">
              <p>
                The Community Bitcoin Reserve movement brings Bitcoin adoption to the community
                level. Each reserve represents a local group of individuals who pool resources
                into a shared, transparent Bitcoin treasury — secured not by any single person,
                but by multi-signature technology that requires consensus among key holders.
              </p>

              <p>
                Multisig governance ensures that no single individual can unilaterally access
                or move funds. Typically configured as 2-of-3 or 3-of-5 key arrangements,
                these vaults distribute trust across community leaders, creating a resilient
                and censorship-resistant savings mechanism for neighborhoods across America.
              </p>

              <p>
                Each reserve operates independently with its own leadership, goals, and community
                initiatives. From education programs to local merchant adoption drives, reserves
                serve as hubs for grassroots Bitcoin culture — proving that sound money starts
                at the neighborhood level.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
